import { useState } from "react";
import { t, getLang } from "@/lib/i18n";
import en from "@/locales/terms_en.json";
import fr from "@/locales/terms_fr.json";
import pt from "@/locales/terms_pt.json";
import es from "@/locales/terms_es.json";

const TRANSLATED = { fr, pt, es };
const LANG_NAMES = { fr: "Français", pt: "Português", es: "Español" };

function Sections({ sections, testId }) {
  return (
    <div className="space-y-6" data-testid={testId}>
      {sections.map(([title, paras]) => (
        <section key={title}>
          <h3 className="font-display font-bold text-base text-slate-900 mb-2">{title}</h3>
          <div className="space-y-2">{paras.map((p, i) => <p key={i}>{p}</p>)}</div>
        </section>
      ))}
    </div>
  );
}

export default function TermsContent({ version }) {
  const lang = getLang();
  const translated = TRANSLATED[lang];
  const [view, setView] = useState(translated ? "translated" : "en");
  const tab = (key, label) => (
    <button type="button" onClick={() => setView(key)} data-testid={`terms-tab-${key}`}
      className={`h-9 px-4 rounded-full text-xs font-bold transition-colors ${view === key ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
      {label}
    </button>
  );

  return (
    <div className="space-y-6 text-sm leading-relaxed text-slate-700" data-testid="terms-content">
      <p className="font-mono text-xs uppercase tracking-wider text-slate-500">Version {version || "2026-07"}</p>
      {translated && (
        <>
          <div className="flex flex-wrap gap-2">
            {tab("translated", LANG_NAMES[lang])}
            {tab("en", `English · ${t("legally binding")}`)}
          </div>
          <p className="p-3 rounded-xl bg-amber-50 border border-amber-200 text-amber-900" data-testid="terms-english-note">
            {t("This translation is provided for convenience only. If there is any difference between versions, the English version is the legally binding version.")}
          </p>
        </>
      )}
      <Sections sections={view === "en" ? en : translated} testId={view === "en" ? "terms-english" : "terms-translated"} />
    </div>
  );
}
